import axios from 'axios'

import environment from '@/environment'
import type { MarketProgram } from '@/features/site/types/marketProgram'

export const MARKET_PROGRAMS_API_URL = `${environment.services.monolithGatewayManagerApiUrl}/marketPrograms`

export const GET_MARKET_PROGRAMS_API_ID = 'GET_MARKET_PROGRAMS'

export async function getMarketPrograms(): Promise<MarketProgram[]> {
  const response = await axios.get<MarketProgram[]>(MARKET_PROGRAMS_API_URL)

  // needed because the API returns 2 instances of FFR UP
  const uniqueMarketPrograms = new Map(response.data.map((marketProgram) => [marketProgram.id, marketProgram])).values()
  return Array.from(uniqueMarketPrograms)
}
